import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Box, Dialog, Link, Stack, styled, Typography } from "@mui/material";
import image1 from "assets/image/footer/footer1.png";
import image2 from "assets/image/footer/footer2.png";
import image3 from "assets/image/footer/footer3.png";
import Iconify from "components/Iconify";
import { user as userVar, isAuth } from "apollo/cache";
import ReactGA from "react-ga4";

import Feedback from "components/Feedback";
import { useReactiveVar } from "@apollo/client";
import { useEffect } from "react";
import { WhatIsNewFullScreen } from "sections/whatIsNew";
import { APP_VERSION } from "config";

const Img = styled("img")(({ theme }) => ({
  [theme.breakpoints.up("xs")]: {
    height: 60,
  },
  [theme.breakpoints.up("md")]: {
    height: 70,
  },
}));

export default function Footer() {
  const { t } = useTranslation();
  const [openNewFeature, setOpenNewFeature] = useState(false);
  const user = useReactiveVar(userVar);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    ReactGA.event("click_navigation", {
      component: "footer",
      link: "feedback",
    })
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (user?.isFeedbackShowUp) {
      handleClickOpen();
      userVar({
        ...user,
        isFeedbackShowUp: false,
      });
    }
  }, [user]);

  const ICON_SOCIAL = [
    {
      label: "facebook",
      icon: "fa-brands:facebook-square",
      href: "https://www.facebook.com/easyricetech",
    },
    {
      label: "line",
      icon: "fa-brands:line",
      href: "https://lin.ee/ze5NZ4Y",
    },
    {
      label: "linkedin",
      icon: "fa-brands:linkedin",
      href: "https://www.linkedin.com/company/easy-rice-digital-technology/",
    },
  ];

  return (
    <>
      <Stack
        direction={{ xs: "column-reverse", lg: "row" }}
        justifyContent={{ lg: "space-between" }}
        alignItems={{ xs: "center", md: "flex-start", lg: "flex-end" }}
        spacing={3}
        sx={{ px: { xs: 2.5, sm: 3.75, md: 5 }, py: 3 }}
      >
        <Stack spacing={1}>
          <Stack
            direction={{ xs: "column", sm: "row", md: "column", lg: "row" }}
            rowGap={1}
            columnGap={3}
            alignItems={{ xs: "center", sm: "start" }}
          >
            <Stack spacing={2} direction="row">
              <Box
                sx={{
                  fontSize: 12,
                  color: "#BDBDBD",
                }}
              >
                {t("social media")} :
              </Box>
              {ICON_SOCIAL.map(({ label, icon, href }, i) => (
                <Iconify
                  key={i}
                  icon={icon}
                  sx={{
                    cursor: "pointer",
                    color: "primary.light01",
                    width: 20,
                    height: 20,
                  }}
                  onClick={() => {
                    window.open(href, "_blank").focus();
                    ReactGA.event("click_navigation", {
                      component: "footer",
                      link: label,
                    });
                  }}
                />
              ))}
            </Stack>
            <Stack direction="row" spacing={2}>
              <Link
                variant="body3"
                href="/policy"
                target="_blank"
                color="primary.light01"
                onClick={() =>
                  ReactGA.event("click_navigation", {
                    component: "footer",
                    link: "policy",
                  })
                }
              >
                {t("policy")}
              </Link>
              <Link
                variant="body3"
                href="/term"
                target="_blank"
                color="primary.light01"
                onClick={() =>
                  ReactGA.event("click_navigation", {
                    component: "footer",
                    link: "term",
                  })
                }
              >
                {t("terms_and_conditions")}
              </Link>
              {isAuth() && (
                <Stack direction="row" spacing="4px" alignItems="center">
                  <Link
                    variant="body3"
                    href="#"
                    color="primary.light01"
                    onClick={handleClickOpen}
                  >
                    {t("send_feedback")}
                  </Link>
                </Stack>
              )}
            </Stack>
          </Stack>
          <Stack
            direction={{ xs: "column", sm: "row", md: "column", lg: "row" }}
            spacing={1}
            alignItems={{ xs: "center", sm: "start" }}
          >
            <Typography variant="body3" color="#BDBDBD">
              ⓒ 2022 Easy Rice Digital Technology Co., Ltd. All rights reserved.
            </Typography>
            <Link
              variant="body3"
              color="primary.light01"
              underline="hover"
              onClick={() => {
                ReactGA.event("click_navigation", {
                  component: "footer",
                  link: "new feature",
                })
                setOpenNewFeature(true);
              }}
            >
              Software version {APP_VERSION}
            </Link>
          </Stack>
        </Stack>
        <Stack direction={{ xs: "column", sm: "row" }} alignItems="center" spacing={2}>
          <a
            href="https://www.linkedin.com/posts/easy-rice-digital-technology_apicta2022-easyrice-apicta2022-activity-7008291822263312384-OgKu?utm_source=li_share&utm_content=feedcontent&utm_medium=g_dt_web&utm_campaign=copy"
            target="_blank"
            rel="noreferrer"
          >
            <Img src={image1} alt="APICTA" sx={{ verticalAlign: "bottom" }} />
          </a>
          <a
            href="https://www.linkedin.com/feed/update/urn:li:activity:6971684167403130880"
            target="_blank"
            rel="noreferrer"
          >
            <Img src={image2} alt="ticta" sx={{ verticalAlign: "bottom" }} />
          </a>
          <a href="https://easyrice.ai/about-us#certificate" target="_blank" rel="noreferrer">
            <Img src={image3} alt="iso" sx={{ verticalAlign: "bottom" }} />
          </a>
        </Stack>
      </Stack>
      {openNewFeature && (
        <WhatIsNewFullScreen open={openNewFeature} handleClose={() => setOpenNewFeature(false)} />
      )}
      {/* )} */}
      <Dialog fullScreen open={open} onClose={handleClose}>
        <Feedback onClose={handleClose} />
      </Dialog>
    </>
  );
}
